import {ValueType} from '@/api/meta/filters';
import {ApiSortOrder, ApiSortsDerived} from '@/api/meta/odata';
import {getContacts} from '@/api/module/contact';
import Contact, {ApiContact, ContactFilters} from '@/model/Contact';
import {
  createVersionedStorage,
} from './types';
import {boolToDisplay, fulltextToDisplay} from '@/util/store';

// const filterNames: Record<keyof ContactFilters, string> = {
//   Ausgeschieden: 'Ausgeschieden',
//   Fulltext$Fulltext: 'Suche',
//   KundenNr: 'Kunden-Nr.',
// };

const useContactsStore = createVersionedStorage<
  ContactFilters,
  ApiSortsDerived<ApiContact>,
  Contact[]
>('contacts', {
  fetchFn: getContacts,
  formatter: {
    Ausgeschieden: boolToDisplay('Ja', 'Nein', 'Ausgeschieden'),
    Fulltext$Fulltext: fulltextToDisplay,
  },
  // convertFilterToDisplayFn: createConvertFiltersToDisplayFn(
  //     createGetRowFn({
  //       isHidden: ({actualKeys}) => actualKeys.index === 'KundenNr',
  //       getLabel: ({actualKeys}) => filterNames[actualKeys.index as keyof ContactFilters],
  //     }),
  // ),
  defaultData: [],
  defaultFilters: {
    Fulltext$Fulltext: {words: [], fields: [
      {
        path: ['Vorname'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['Nachname'],
        valueType: ValueType.StringContains,
      },
      {
        path: ['Position'],
        valueType: ValueType.StringContains,
      },
    ]},
    Ausgeschieden: false,
  },
  defaultSorts: [['Nachname', ApiSortOrder.Asc]],
  defaultLimit: 10,
});
export type ContactsStore = ReturnType<typeof useContactsStore>
export default useContactsStore;
